'use client'
import { useMemo } from 'react'
import { logger } from '../logger'
import useUserStore from './zustand-stores/use-user-store'
import { useUser } from '@clerk/nextjs'

export function useLogger() {
  const user = useUserStore(state => state.user)
  const userId = user?._id || null
  const userFullName = user?.fullName || null
  const { user: clerkUser } = useUser()
  const clerkUserId = clerkUser?.id || null
  const clerkUserFullName = clerkUser?.fullName || null

  const loggerWithUserId = useMemo(() => {
    const additionalContext = {
      userId: userId || user?.clerkUserId || clerkUserId,
      userFullName: userFullName || clerkUserFullName,
      hostname:
        typeof window !== 'undefined' ? window.location.hostname : 'server',
      os: typeof window !== 'undefined' ? window.navigator.userAgent : 'server',
      level: 'info',
      timestamp: new Date().toISOString()
    }

    const isProduction = process.env.NODE_ENV === 'production'

    if (isProduction) {
      return logger.child({ ...additionalContext, level: 'silent' })
    } else {
      return logger.child(additionalContext)
    }
  }, [userId, clerkUserId, userFullName, clerkUserFullName])

  return loggerWithUserId
}
